<template>
  <div style="padding: 0 6% 0 2%">
    <h2>重置密码</h2>
    <div style="min-height: 224px">
      <BaseForm ref="baseFormRef" :form-options="formOptions" :form-rules="rules" :form-data="formData" formSize="large" labelWidth="130px" :api-method="resetPwd"
        :showResetButton="false" @submitFormRes="submitFormRes" form-padding="0" label-position="right" :showFooterButton="false" @buttonClick="buttonClick">
      </BaseForm>
    </div>
  </div>
</template>

<script setup name="Reset">

import BaseForm from "@/components/BaseForm/index.vue"

import { arrayFunction } from "@/utils/arrayFunction";
const { findCertainIndex } = arrayFunction()
import useLogin from "@/stores/login";
const loginStore = useLogin();
import { useRouter } from "vue-router";
const router = useRouter();

import {onMounted, reactive, ref, watch} from "vue";
import { getSmsCode, resetPwd } from "@/request/api/login";
import { ElMessage } from "element-plus";

const ratioOption = ref([])

const formOptions = reactive([
  { span:24 ,type:"input" ,prop:"phone",label:"手机号 :",placeholder:"请输入手机号",hide:false },
  { span:22 ,type:"radio" ,prop:"radio",label:"修改方式",options:ratioOption.value},
  { span:24 ,type:"input" ,prop:"oldPassword",label:"旧密码 :",placeholder:"请输入旧密码",inputType:"password",hide:true },
  { span:16 ,type:"input" ,prop:"phoneCode",label:"手机验证码 :",placeholder:"请输入手机验证码",hide:true },
  { span:8 ,type:"button" ,value:"getCode",prop:"获取验证码",labelWidth:"0",buttonType:"info",buttonWidth:"100%",hide:true },
  { span:24 ,type:"input" ,prop:"password",label:"新密码 :",placeholder:"请输入密码" },
  { span:24 ,type:"input" ,prop:"rePassword",label:"确认新密码 :",placeholder:"请输入确认密码",inputType:"password" },
  { span:22 ,type:"button" ,value:"submit",prop:"提交",buttonType:"primary",buttonWidth:"100%",size:"default" },
])

const formData = reactive({
  userId:undefined,
  phone: undefined,// 手机号
  radio:undefined,// 修改方式
  oldPassword:undefined,// 旧密码
  phoneCode: undefined,// 手机验证码
  password: undefined,// 密码
  rePassword: undefined,// 确认密码
})

let baseFormRef = ref()
const buttonClick = (item) =>{
  item.value === "submit" && baseFormRef.value.submitForm()
  item.value === "getCode" && getCode()
}

onMounted(()=>{
  if(loginStore.isLogin){
    ratioOption.value = [{ value:"密码修改",label:"密码修改" },{ value:"验证码修改",label:"验证码修改" }];
    formData.userId = loginStore.userId
  }else {
    ratioOption.value = [{ value:"验证码修改",label:"验证码修改" }];
  }
  formOptions[1].options = ratioOption.value;
  formData.radio = '验证码修改'
})

watch(()=>formData.radio,(newV,oldV)=>{
  if(newV === "密码修改"){
    formOptions[findCertainIndex(formOptions,'prop','oldPassword')].hide = false
    formOptions[findCertainIndex(formOptions,'prop','phone')].hide = true
    formOptions[findCertainIndex(formOptions,'prop','phoneCode')].hide = true
    formOptions[findCertainIndex(formOptions,'value','getCode')].hide = true
    formData['phoneCode'] = undefined
  }else if(newV === "验证码修改"){
    formOptions[findCertainIndex(formOptions,'prop','oldPassword')].hide = true
    formOptions[findCertainIndex(formOptions,'prop','phone')].hide = false
    formOptions[findCertainIndex(formOptions,'prop','phoneCode')].hide = false
    formOptions[findCertainIndex(formOptions,'value','getCode')].hide = false
    formData['oldPassword'] = undefined
  }else{
    formOptions[findCertainIndex(formOptions,'prop','oldPassword')].hide = true
    formOptions[findCertainIndex(formOptions,'prop','phone')].hide = false
    formOptions[findCertainIndex(formOptions,'prop','phoneCode')].hide = true
    formOptions[findCertainIndex(formOptions,'value','getCode')].hide = true
    formData['phoneCode'] = undefined
    formData['oldPassword'] = undefined
  }
})

const submitFormRes = (res) =>{
  if(res.status == 10000){
    ElMessage({message: "重置成功",type: "success"});
    loginStore.isLogin = false;
    loginStore.token = "";
    loginStore.showVisible = false;
    router.push({path: "/"});
  }else{
    ElMessage({message: res.msg,type: "error",});
  }
}

/**
 * 再次确认密码
 */
const checkPassword = (rule, value, callback) => {
  value ? formData.password === formData.rePassword ? callback() : callback(new Error("两者密码不一致")) : callback(new Error("请再次输入登录密码"))
};
/**
 * 校验手机格式
 */
const checkMobile = (rule, value, cb) => {
  const regMobile =
      /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
  if (regMobile.test(value)) {
    // 合法的手机号码
    return cb();
  }
  cb(new Error("手机号码格式不正确"));
};
/**
 * 校验规则
 */
const rules = reactive({
  phone: [{ required: true, message: "请输入手机号", trigger: "blur" },{ validator: checkMobile, trigger: ["blur", "change"] }],
  radio: [{ required: true, message: "请选择修改方式", trigger: "change" }],
  oldPassword: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
  phoneCode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
  password: [{ required: true, message: "请输入登录密码", trigger: "blur" },{ min: 6, max: 20, message: "密码位数范围需在6-20内", trigger: "blur" }],
  rePassword: [{ required: true, validator: checkPassword, trigger: "blur" }],
});
//获取手机验证码
const getCode = async() =>{
  let res = await getSmsCode({ phone: formData.phone,type: "1" })
  res.status === 10000 ? ElMessage({ message: "发送成功",type: "success",}) : ElMessage({  message: "发送失败",type: "error",})
};

</script>

<style lang="scss" scoped>
@import "@/styles/elementButton.scss";
@import "@/styles/common.scss";
@import "@/styles/variables.scss";
h2 {
  margin: 0 0 30px 0;
  text-align: center;
  color: #000;
}
</style>
